module.exports = __webpack_public_path__ + "static/media/desktop-emp.d8eb65ca.jpg";